import {AgGridVue} from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import moduleResource from "@/store/resource/moduleResource.js";
import CellRendererLink from "@/components/resource/user-list/cell-renderer/CellRendererLink.vue";
import CellRendererStatus from "@/components/resource/user-list/cell-renderer/CellRendererStatus.vue";
import CellRendererActions from "@/components/resource/user-list/cell-renderer/CellRendererActions.vue";

window.numberParser = function numberParser(params) {
	return Number(params.newValue) | 0;
};

export const resourceListMixin = {
	name: "ResourceList",
	props: {
		status_id: {
			type: Array,
			default: () => [],
		},
		removeColumns: {
			type: Boolean,
			default: () => false,
		},
		relatedIds: {
			type: Array,
			default: () => [],
		},
		resourceListConfig: {
			type: Object,
			default: () => {
				return {
					rowSelection: "single",
					activeCheckbox: false,
					columns: [],
					actions: true,
					link: true,
					tableOptions: true,
					popupMode: false,
					showItemsPerPage: true,
					showBtnNewResource: true,
					showSelectedResource: false,
				};
			},
		},
		showBtnCreate: {
			type: Boolean,
			default: () => true,
		},
		filterResources: {
			type: Boolean,
			default: () => false,
		},
		componentParent: {
			type: String,
			default: "RESOURCE_LIST",
		},
		maxSelectedRows: {
			type: Number,
			default: 0,
		},
	},
	components: {
		AgGridVue,
		vSelect,
		CellRendererLink,
		CellRendererStatus,
		CellRendererActions,
	},
	data() {
		return {
			searchQuery: [],
			showSelected: false,
			showSearch: false,
			currentPageLocal: 1,
			quantityElementPage: 15,
			searchField: "Identification",
			gridApi: null,
			gridOptions: {},
			isExactly: false,
			defaultColDef: {
				sortable: true,
				resizable: true,
				suppressMenu: true,
			},
			pagination: {
				next_page: 0,
				total_pages: 0,
				total_records: 0,
			},
			components: {
				CellRendererLink,
				CellRendererStatus,
				CellRendererActions,
			},
			columnsConfigWidth: {
				email: this.removeColumns ? 350 : 450,
				lastname: 250,
				name: this.removeColumns ? 250 : 200,
				username: this.removeColumns ? 250 : 200,
				address: this.removeColumns ? 300 : 250,
				city: this.removeColumns ? 250 : 200,
			},
		};
	},
	watch: {
		currentPageLocal(page) {
			this.getListResources(page);
		},
		quantityElementPage() {
			this.getListResources(1);
		},
	},
	computed: {
		overlayLoadingTemplate() {
			return `<div class="ring">${this.$t("Loading")}<span></span></div>`;
		},
		overlayNoRowsTemplate() {
			return `<span style="font-size: 14px; font-weight: 500; color: grey">${this.$t("NoDataAvailable")}</span>`;
		},
		isWidthPortatil() {
			return window.innerWidth <= 1366;
		},
		columnDefs() {
			let filterHead =
				this.resourceListConfig.filterHead !== undefined ? this.resourceListConfig.filterHead : true;
			// Columns
			let columns = [
				{
					headerName: this.$t("ResourceModule.Table.Identification"),
					field: "identification",
					width: 250,
					filter: filterHead,
					headerCheckboxSelectionFilteredOnly: true,
					checkboxSelection:
						this.resourceListConfig.activeCheckbox !== undefined
							? this.resourceListConfig.activeCheckbox
							: true,
					headerCheckboxSelection:
						this.resourceListConfig.activeCheckbox !== undefined
							? this.resourceListConfig.activeCheckbox
							: true,
				},
				{
					headerName: this.$t("ResourceModule.Table.Username"),
					field: "username",
					filter: filterHead,
					width: this.columnsConfigWidth.username,
				},
				{
					headerName: this.$t("Name"),
					field: "name",
					filter: filterHead,
					width: this.columnsConfigWidth.name,
				},
				{
					headerName: this.$t("ResourceModule.Table.Lastname"),
					field: "lastname",
					filter: filterHead,
					width: this.columnsConfigWidth.lastname,
				},
				{
					headerName: this.$t("ResourceModule.Table.Email"),
					field: "email",
					filter: filterHead,
					width: this.columnsConfigWidth.email,
				},
				{
					headerName: this.$t("ResourceModule.Table.Role"),
					field: "role_name",
					filter: filterHead,
					width: 150,
				},
				{
					headerName: this.$t("ResourceModule.Table.Status"),
					field: "status",
					filter: filterHead,
					width: 150,
					cellRendererFramework: "CellRendererStatus",
				},
				{
					headerName: this.$t("ResourceModule.Table.Actions"),
					field: "transactions",
					width: 120,
					cellRendererFramework: "CellRendererActions",
					pinned: "right",
				},
			];
			// Filter table columns to show if showColumns is provided
			const showColumns =
				this.resourceListConfig.columns !== undefined && this.resourceListConfig.columns.length > 0
					? this.resourceListConfig.columns
					: [];
			if (showColumns.length > 0) {
				columns = columns.filter((column) => {
					if (showColumns.includes(column.field)) {
						return column;
					}
				});
			}
			return columns;
		},
		paginationPageSize() {
			if (this.pagination.total_records > 0) {
				return this.pagination.total_records;
			} else {
				return 0;
			}
		},
		totalPages() {
			if (this.pagination.total_pages > 0) return this.pagination.total_pages;
			else return 0;
		},
		searchSelected() {
			return this.$t(`ResourceModule.Table.${this.searchField}`);
		},
		resourcesData() {
			return this.$store.state.moduleResource.resources;
		},
		currentPage: {
			get() {
				return this.currentPageLocal;
			},
			set(val) {
				this.currentPageLocal = val;
			},
		},
		getCheckedResources() {
			return this.$store.state.moduleResource.checkedResources;
		},
	},
	methods: {
		onBtShowLoading() {
			this.gridApi.showLoadingOverlay();
		},
		onBtHide() {
			this.gridApi.hideOverlay();
		},
		getListResources(page) {
			this.onBtShowLoading();
			const payload = {
				page,
				quantity: this.quantityElementPage,
				status_id: this.status_id,
				match_filter: !this.isExactly,
				sort: "desc",
				order_by: ["id"],
			};
			this.$store
				.dispatch("moduleResource/fetchResourceFilterPaginate", payload)
				.then((res) => {
					Object.assign(this.pagination, res.data.pagination);
					setTimeout(() => {
						this.resetColFilters();
						this.setDefaultSelectedRow();
					}, 100);
					this.onBtHide();
				})
				.catch((err) => {
					this.onBtHide();
					console.error(err);
				});
		},
		resetColFilters() {
			this.gridApi.setFilterModel(null);
			this.gridApi.onFilterChanged();
		},
		searchResource() {
			const searchQueryList = this.searchQuery.map(({value}) => value);
			const dataPage = {
				identification: this.searchField === "Identification" ? searchQueryList : [],
				name: this.searchField === "Name" ? searchQueryList : [],
				email: this.searchField === "Email" ? searchQueryList : [],
				role_name: this.componentParent === "VEHICLE" ? ["EXECUTIVE", "SUPERVISOR"] : [],
				status_id: this.status_id,
				exist_in_vehicle: this.componentParent === "VEHICLE" ? [false] : [],
				match_filter: !this.isExactly,
				order_by: ["id"],
				sort: "asc",
			};
			this.onBtShowLoading();
			this.$store
				.dispatch("moduleResource/fetchResourceFilterPaginate", dataPage)
				.then((res) => {
					this.showSearch = true;
					Object.assign(this.pagination, res.pagination);
					setTimeout(() => {
						this.resetColFilters();
						this.setDefaultSelectedRow();
					}, 100);
					this.onBtHide();
				})
				.catch((err) => {
					this.onBtHide();
					console.error(err);
				});
		},
		searchAssignedResource(searchField, searchQuery, page) {
			const searchQueryList = searchQuery.map(({value}) => value);
			const dataPage = {
				identification: searchField === "Identification" ? searchQueryList : [],
				name: searchField === "Name" ? searchQueryList : [],
				email: searchField === "Email" ? searchQueryList : [],
				role_name: this.componentParent === "VEHICLE" ? ["EXECUTIVE", "SUPERVISOR"] : [],
				page: page ? page : currentPageLocal,
				exist_in_vehicle: this.componentParent === "VEHICLE" ? [false] : [],
				status_id: this.status_id,
				match_filter: !this.isExactly,
				order_by: ["id"],
				sort: "asc",
			};
			this.onBtShowLoading();
			this.$store
				.dispatch("moduleResource/fetchResourceFilterPaginate", dataPage)
				.then((res) => {
					Object.assign(this.pagination, res.pagination);
					setTimeout(() => {
						this.resetColFilters();
						this.setDefaultSelectedRow();
					}, 100);
					this.onBtHide();
				})
				.catch((err) => {
					this.onBtHide();
					console.error(err);
				});
		},
		addNewResource() {
			this.$router.push({name: "app-resource-create"});
		},
		generateOptionSelect(data, propLabel, propValue) {
			return data.map((d) => {
				return {label: d[propLabel], value: d[propValue]};
			});
		},
		paginationSetPageSize(num) {
			this.gridApi.paginationSetPageSize(num);
			this.quantityElementPage = num;
		},
		rowSelected(event) {
			if (this.componentParent === "VEHICLE" && this.maxSelectedRows > 0) {
				if (this.getCheckedResources.length >= this.maxSelectedRows) {
					this.gridApi.getRowNode(event.rowIndex).setSelected(false);
					this.$vs.notify({
						color: "warning",
						title: this.$t("RouterSelection.Step2Title"),
						text:
							this.$t("MaxSelectedResourcesReached") +
							" " +
							this.getCheckedResources.length +
							"/" +
							this.maxSelectedRows,
						time: 7000,
					});
				}
			}
			const isSelected = event.node.isSelected();
			if (isSelected) {
				this.$store.commit("moduleResource/ADD_RESOURCE_CHECKED", event.data);
			} else {
				this.$store.commit("moduleResource/DEL_RESOURCE_CHECKED", event.data);
			}
		},
		onSelectionChanged() {
			const selectedRows = this.getCheckedResources;
			if (this.resourceListConfig.rowSelection === "single") {
				this.$store.dispatch("moduleResource/currentResourceSelected", selectedRows[0]);
			} else {
				this.$store.dispatch("moduleResource/setSelectedResource", selectedRows);
			}
		},
		setDefaultSelectedRow() {
			const relatedIds = this.getCheckedResources;
			if (relatedIds.length > 0) {
				this.gridApi.forEachNode((node) => {
					const valid = relatedIds.some((r) => r.id === node.data.id);
					node.setSelected(valid);
				});
			}
		},
		refreshResource() {
			this.showSelected = false;
			this.showSearch = false;
			this.searchQuery = [];
			this.currentPageLocal = 1;
			this.$store.commit("moduleResource/REMOVE_ALL_RESOURCE_CHECKED");
			this.getListResources(1);
		},
		setSearchField(val) {
			this.searchField = val;
		},
		selectedResources(initValue) {
			if (this.getCheckedResources.length >= initValue) {
				this.gridApi.setRowData(this.getCheckedResources);
				this.setDefaultSelectedRow();
				this.showSelected = true;
			}
		},
		openEnableConfirm(val) {
			if (val) {
				this.$vs.dialog({
					type: "confirm",
					color: "primary",
					title: this.$t("Confirm"),
					text: `${this.$t("Preferences.FilterSearchExactText")}`,
					accept: () => {
						this.isExactly = val;
						this.updateMatchFilter();
					},
					cancel: () => {
						this.isExactly = false;
					},
					acceptText: this.$t("Accept"),
					cancelText: this.$t("Cancel"),
				});
			} else {
				this.isExactly = val;
				this.updateMatchFilter();
			}
		},
		async updateMatchFilter() {
			const payload = {};
			payload["filter_exact_resource"] = this.isExactly;
			try {
				await this.$store.dispatch("moduleMatchFilter/updateMatchFilter", payload);
			} catch (error) {
				this.$vs.notify({
					color: "danger",
					title: this.$t("ErrorTitle"),
					text: this.$t("ErrorMessage"),
				});
			}
		},
	},
	async mounted() {
		this.gridApi = this.gridOptions.api;
		if (this.$vs.rtl) {
			const header = this.$refs.agGridTable.$el.querySelector(".ag-header-container");
			header.style.left = `-${String(Number(header.style.transform.slice(11, -3)) + 9)}px`;
		}
		const matchFilter = await this.$store.dispatch("moduleMatchFilter/getMatchFilter");
		if (Object.entries(matchFilter) > 0) {
			this.isExactly = matchFilter.filter_exact_resource;
		} else {
			this.isExactly = this.$store.state.moduleMatchFilter.filter_exact_resource;
		}
		this.$emit("gridApiEmit", this.gridApi);
		this.getListResources(1);
	},
	created() {
		if (!moduleResource.isRegistered) {
			this.$store.registerModule("moduleResource", moduleResource);
			moduleResource.isRegistered = true;
		}
	},
};
